import { useState, createContext, useEffect } from "react"
import { COOKIE, getCookie } from "./services/cookie";
const Context = createContext()

function ContextProvider(props) {
	const [collapsed, setCollapsed] = useState(false)
	const [user, setUser] = useState({
		firstName: getCookie(COOKIE.FirstName) || "",
		lastName: getCookie(COOKIE.LastName) || "",
	});
	const [chapterList, setChapterList] = useState(() => {
		const stored = localStorage.getItem("chapter-list");
		return stored ? JSON.parse(stored) : [];
	});
	function toggleSidebar() {
		setCollapsed(!collapsed)
	}

	useEffect(() => {
		const isEdge = window.navigator.userAgent.indexOf('Edg') > -1;

		if (isEdge) {
			// Apply Edge-specific styles
			document.body.classList.add('edge');
		}
	}, []);
	return (
		<Context.Provider value={{
			collapsed,
			toggleSidebar,
			user,
			setUser,
			chapterList,
			setChapterList
		}}>
			{props.children}
		</Context.Provider>
		)
}
export {ContextProvider,Context}
